export default {
  roadmapMetadata: {
    changeMentorTitle: 'Appoint a mentor',
    createMaterialTitle: 'New material',
    changeMaterialTitle: 'Edit the material',
    formLabels: {
      name: 'Name of the material',
      skillId: 'Competence',
      deadline: 'Deadline',
      typeId: 'Type of material',
      importance: 'Importance',
    },
    statuses: {
      all: 'All',
      new: 'New',
      inProgress: 'In progress',
      done: 'Done',
    },
    addMaterialFieldsButton: 'Add a material',
    removeMaterialFieldsButton: 'Delete the material',
    moveMaterialsButton: {
      top: 'Move to other skills for development',
      general: 'Move to obvious growth zones',
    },
    headers: {
      name: 'Name',
      type: 'Type',
      importance: 'Importance',
      deadline: 'Deadline',
      status: 'Status',
    },
    tooltips: {
      manualMaterial: 'The material created in the development plan',
      manualTask: 'The task created in the development plan',
      showMaterial: 'The material added to the board',
      showTask: 'The task added to the board',
      supervisorButton: 'Why update and fix the development plan',
      employeeButton: 'Why update the development plan',
      employee:
        'Update the development plan to get the most up-to-date results based on the latest estimates. Note that the current progress will be reset, only tasks that were added to the plan manually will not be deleted.',
      supervisor:
        'Update the development plan to get the most up-to-date results based on the latest estimates. Note that the current progress will be reset, only tasks that were added to the plan manually will not be deleted. After fixing the plan, the «Update development plan» button will become unavailable, but you will be able to add, delete and move tasks between blocks.',
      button: 'Why update and fix the development plan',
      text: 'Update the development plan to get the most up-to-date results based on the latest estimates. Note that the current progress will be reset, only tasks that were added to the plan manually will not be deleted. After fixing the card, the «Update development plan» button will become unavailable. Making changes to the plan will also become impossible.',
    },
    selectDateButton: 'Select a date',
    selectImportanceButton: 'Select a importance',
    devPlanTitle: 'Competence development plan',
    recreateRoadmapButton: 'Update development plan',
    fixateRoadmapButton: 'Fixate changes',
    requiredTarget: 'The «Target Description» and «Deadline» fields are required',
    commonMaterialsTitle: 'Common materials and tasks for development',
    blocksMaterialsTitle: 'Materials and tasks based on the assessment results',
    topSectionTitle: 'Obvious growth areas',
    generalSectionTitle: 'Other materials and tasks for development',
    progressDescription: 'Overall progress of the development plan',
    lowSkills: 'Competencies for which the user has the lowest evaluations',
    // messages
    successMessages: {
      changeMentor: 'Mentor successfully changed',
      saveTarget: 'Target saved successfully',
      createMaterial: 'The material successfully created',
      changeMaterial: 'The material successfully changed',
      showMaterials: 'The materials successfully added to the board',
      moveMaterials: 'The materials successfully moved',
      deleteMaterials: 'The materials successfully deleted',
      changeTask: 'The task successfully changed',
      recreateRoadmap: 'The development plan successfully updated',
      fixateRoadmap: 'The development plan successfully fixed',
    },
    errorMessages: {
      changeMentor: 'Failed to change the mentor',
      saveTarget: 'Failed to save the target',
      createMaterial: 'Failed to create a material',
      changeMaterial: 'Failed to change the material',
      showMaterials: 'Failed to add the materials to the board',
      moveMaterials: 'Failed to move the materials',
      deleteMaterials: 'Failed to delete the materials',
      changeTask: 'Failed to change the task',
      recreateRoadmap: 'Failed to update the development plan',
      fixateRoadmap: 'Failed to fixate the development plan',
      targetRoadmap: 'You need to fill in the «Target» field to fixate your development plan',
    },
    // confirm dialogs
    confirmShowMaterials: {
      title: 'Add materials to the board?',
      button: 'Yes, add',
    },
    confirmMoveMaterials: {
      title: 'Move the materials?',
      button: 'Yes, move',
    },
    confirmDeleteMaterials: {
      title: 'Delete the materials?',
      text: 'It will be impossible to cancel this action',
    },
    confirmRecreateRoadmap: {
      title: 'Update the development plan?',
      text: 'The development plan will be recreated and the changes will be lost.',
      button: 'Yes, update',
    },
    confirmFixateRoadmap: {
      title: 'Fixate the development plan?',
      text: 'Making changes to the composition of the development plan will become unavailable.',
      button: 'Yes, fixate',
    },
    //
  },
};
